'use strict'

const TOPBAR_SECTIONS = [
  { id: 'spreadsheets', icon: 'table', label: 'spreadsheets' },
  { id: 'design', icon: 'drafting-compass', label: 'design' },
  { id: 'automations', icon: 'bolt', label: 'automations' },
  { id: 'workflows', icon: 'code-branch', label: 'workflows' },
  { id: 'ai-build', icon: 'wand-magic-sparkles', label: 'ai build' },
  { id: 'ai-query', icon: 'robot', label: 'ai query' },
  { id: 'settings', icon: 'cog', label: 'app settings' },
  { id: 'analytics', icon: 'chart-bar', label: 'analytics' }
]

function topbarNeedsMenu (availableWidth, requiredWidth) {

  const available = Number(availableWidth)
  const required = Number(requiredWidth)

  if (!Number.isFinite(available) || !Number.isFinite(required)) return false

  if (required <= 0 || available <= 0) return false

  return required - available > 0.5
}

module.exports = {
  TOPBAR_SECTIONS,
  topbarNeedsMenu
}
